<script>
  import MeteorList from "@/components/MeteorList.svelte";
  import ScannerLink from "@/components/ScannerLink.svelte";
  import { formatNumber } from "@/utils";
  export let searchText, route, send, receive, url;
  const queryFields = [
    {
      key: "InStock",
      type: "dropdown",
      name: "på lager",
      value: undefined,
      options: [
        {
          name: "alle"
        },
        { name: "ja", value: { $ne: 0 } },
        { name: "nej", value: 0 }
      ]
    }
  ];
  const queryOptions = { limit: 50 };
  const props = {
    searchText,
    route,
    send,
    receive,
    url,
    queryFields,
    queryOptions
  };
</script>

<div class="absolute inset-0 pb-16">
  <div class="relative w-full h-full">
    <MeteorList
      fulltext={$searchText}
      collectionName="products"
      unitName="produkt"
      unitNamePlural="produkter"
      {...props}
      let:collection>
      <ul class="rows">
        <li class="hidden sm:flex font-bold py-1 px-2">
          <div class="w-2/12">ID</div>
          <div class="w-5/12">Navn</div>
          <div class="w-3/12">Type</div>
          <div class="w-1/12 text-right">Pris</div>
          <div class="w-1/12 text-right">Antal</div>
        </li>
        {#each Object.entries(collection) as [key, item]}
          <li class=" border-b sm:border-none py-2 sm:py-0 text-gray-700">
            <a
              href={url('./:id', { id: item._id })}
              class="flex flex-wrap py-1 px-2">
              <div
                class="sm:w-5/12 w-full text-gray-900 font-semibold pb-1 sm:pb-0">
                {item.ItemText1 || ''}
              </div>
              <div class="sm:w-2/12 w-full sm:order-first pb-1 sm:pb-0">
                {item.ItemNumber}
              </div>
              <div class="sm:w-3/12 w-full">{item.GeneralType || ''}</div>
              <div class="sm:w-1/12 sm:text-right">
                <span class="sm:hidden font-semibold ">Pris:</span>
                {#if item.Price}
                  {#each item.Price as price, i}
                    {#if price.PriceQuantity == 1}
                      {formatNumber(price.Price, 2)}
                    {/if}
                  {/each}
                  {#if item.Price.length > 1}
                    <span class="absolute pl-2">({item.Price.length})</span>
                  {/if}
                {/if}

              </div>
              <div class="sm:w-1/12 sm:text-right">
                <span class="sm:hidden pl-6 font-semibold">Lager:</span>
                {item.InStock}
              </div>

            </a>
          </li>
        {/each}
      </ul>
      <div slot="slot">
        <slot>
          <!-- optional fallback -->
        </slot>
      </div>
    </MeteorList>
  </div>
</div>

<!-- BOTTOM NAV -->
<nav
  class="absolute h-16 bottom-0 left-0 right-0 overflow-auto bg-white shadow-2xl
  flex flex-wrap justify-center content-center">

  <ScannerLink />
</nav>
